import React, { memo } from 'react';
import { pdfStyles } from '../../pdfStyles';
import { Page } from '@react-pdf/renderer';
import { FooterCompany } from '../../comps';
import { isEqual } from 'lodash';
import { ColorSet } from 'src/redux/reducers/theme';
import { useAuth } from 'src/state/auth';
import { AssessmentPdfQuery } from 'src/graphql/_generated';

interface AssessmentEndProps {
  assessment: AssessmentPdfQuery['assessment'];
  colors: ColorSet;
  logoSrc?: string;
  primaryColor?: string | null;
  secondaryColor?: string | null;
}

export const AssessmentEnd: React.FC<AssessmentEndProps> = memo(
  ({ assessment, colors, logoSrc, primaryColor, secondaryColor }) => {
    const { profile } = useAuth();

    return (
      <Page size={'A4'} wrap style={pdfStyles.page}>
        <FooterCompany
          companyName={profile?.activeWorkspace?.name || ''}
          title={assessment?.name || ''}
          label="RISK ASSESSMENT"
          companyImage={''}
          colors={colors}
          logoSrc={logoSrc}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
        />
      </Page>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
);
